import type { MantineColorsTuple } from "@mantine/core";

export const brandColors: MantineColorsTuple = [
    "#e5f7fd",
    "#d3eef8",
    "#a8dced",
    "#79c8e2",
    "#52b8d8",
    "#38add2",
    "#29a7d0",
    "#1791b8",
    "#0a81a6",
    "#007194",
];

export const accentColors: MantineColorsTuple = [
    "#ffedf4",
    "#ffd9e7",
    "#f9b0cb",
    "#f483ac",
    "#ef5d92",
    "#ec407a",
    "#eb2f6f",
    "#d11d5d",
    "#bb1152",
    "#a40045",
];

export const mossColors: MantineColorsTuple = [
    "#eef6eb",
    "#dfe9d8",
    "#bdd1b1",
    "#98b687",
    "#78a164",
    "#628f4c",
    "#568644",
    "#467535",
    "#3a672b",
    "#2d5820",
];

export const sandColors: MantineColorsTuple = [
    "#fffaf0",
    "#f7f0e1",
    "#ede0be",
    "#e1ce97",
    "#d8bf77",
    "#d2b25f",
    "#d0ac52",
    "#b79642",
    "#a28639",
    "#8d732d",
];

export const slateColors: MantineColorsTuple = [
    "#f2f5f7",
    "#e4e9ec",
    "#c7d0d7",
    "#a7b5bf",
    "#8da0ac",
    "#7b919f",
    "#718897",
    "#607787",
    "#546978",
    "#475b6a",
];
